module.exports = __webpack_public_path__ + "img/swiper_3.0_1_3.827b4871.webp";